module.exports = __webpack_public_path__ + "07_long_yellow.d52f7c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/07_long_yellow.png
// module id = hU7l
// module chunks = 0